import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { RouteConstants } from './constants/route-constants';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from './services/authentication.service';
import { AppConstants } from './constants/app-constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarUtil } from './utils/snackbar-util';
import { AppConfigService } from './app-config.service';
import { LocationStrategy } from '@angular/common';
import { VideoStreamService } from './services/video-stream.service';
import { ThemeService } from './services/theme.service';
import { UiMessageService } from './services/ui-message.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
	title = 'ramsys';
	errorMessage: any;
	lang: any;

	constructor(private router: Router, private authenticationService: AuthenticationService,
		public translate: TranslateService, public appConfigService: AppConfigService,
		private locationStrategy: LocationStrategy, public videoStreamService: VideoStreamService,
		public _snackBar: MatSnackBar, private themeService: ThemeService, private ui: UiMessageService) {
		translate.setDefaultLang('en');
		translate.addLangs(['en']);
		translate.use(this.translate.getBrowserLang());
	}

	ngOnInit(): void {
		this.router.events.subscribe((event) => {
			document.body.classList.remove('nb-theme-dark');
		});
		this.setLanguage();
		const authToken = this.authenticationService.getAuthToken();
		if (authToken !== null && authToken !== '') {
			this.authenticationService.verifySession(authToken).then(
				Response => {
					if (AppConstants.SUCCESS in Response) {
						if (Response[AppConstants.SUCCESS] === true) {
							this.authenticationService.poll();
							this.goToHome();
						} else {
							this.goToLogin();
						}
					} else {
						this.goToLogin();
					}
				},
				Error => {
					this.errorMessage = Error.message;
					this.goToLogin();
				});
		} else {
			this.goToLogin();
		}

		SnackbarUtil.getSnackBarAddedLister().subscribe(error => this.showSnackBar(error));
		this.preventBackButton();

		// Initialize theme service - this will apply the saved theme or default to dark
		this.themeService.setTheme(this.themeService.getCurrentTheme());

		// Initialize UI message service
		this.ui.init();

	}

	async setLanguage() {
		this.lang = await this.authenticationService.getLanguage();
		if (this.lang) {
			this.useLanguage(this.lang);
		}
	}

	useLanguage(language: string): void {
		this.translate.use(language);
	}

	goToLogin() {
		this.router.navigate([RouteConstants.PAGES + RouteConstants.LOGIN]);
	}

	goToHome() {
		if (!this.router.url.startsWith(RouteConstants.PAGES + RouteConstants.HOME)) {
			this.router.navigate([RouteConstants.PAGES + RouteConstants.HOME]);
		}
	}

	showSnackBar(error: any) {
		// const message = error.error.errorMessages[0].message || (error.status + ' ' + error.statusText);
		// const confirmText = this.translate.instant('ANALYTICAL_FILTERS.OKAY_TEXT');
		// this.openSnackBar(message, confirmText);
	}

	openSnackBar(message: string, action: string) {
		return this._snackBar.open(message, action, {
			horizontalPosition: 'center',
			verticalPosition: 'top'
		});
	}

	// Disable back button
	preventBackButton() {
		history.pushState(null, null, window.location.href);
		this.locationStrategy.onPopState(() => {
			history.pushState(null, null, window.location.href);
		})
	}

	// Detecting Closing Broswer Events:
	public doUnload(): void {
		//
	}

}
